import type {
  BatchIdentificationResults,
  BatchImportMode,
  BatchImportPreview,
} from './batch-transfer';
import type { ChecklistCorrectionsFile, ChecklistCorrectionPreview } from './checklist-corrections';

/** Package files remain within the existing results allowance in aggregate. */
export const COMBINED_PACKAGE_MAX_BYTES = 2 * 1024 * 1024;
export const COMBINED_PACKAGE_MAX_CORRECTION_BYTES = 512 * 1024;
/**
 * RFC-0005 P1.1: the package was staged from the owner's review export. The owner's review is the human
 * attestation; TCVS records the export digest and the digest of the exact staged results it covers.
 */
export interface CombinedPackageReviewProvenance {
  kind: 'OWNER_REVIEW_EXPORT';
  /** SHA-256 (hex) of the owner's review export file, supplied by the stager. */
  reviewDigest: string;
  /** TCVS-computed digest of the staged results; reviewed-apply re-verifies it. */
  resultsDigest: string;
}
export interface CombinedIdentificationPackage {
  packageId: string;
  batchId: string;
  exportId: string;
  createdAt: string;
  createdBy: string;
  expiresAt: number;
  payloadDigest: string;
  importMode: BatchImportMode;
  results: BatchIdentificationResults;
  corrections?: ChecklistCorrectionsFile;
  /** Diagnostic reports; operation receipts remain authoritative. */
  reportIds?: string[];
  catalogRevision?: number;
  reviewProvenance?: CombinedPackageReviewProvenance;
}
export interface CombinedPackagePreview {
  package: CombinedIdentificationPackage;
  current: BatchImportPreview;
  hypothetical?: Omit<BatchImportPreview, 'previewToken'>;
  corrections?: ChecklistCorrectionPreview;
  dependencies: Array<{ cardId: string; correctionIds: string[] }>;
  reportId?: string;
}
